import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { TokenizedPaymentCard } from '@/models';
import { makeUniqueValue, UniqueValue } from '@/helpers';

@Component({
  name: 'CmgCheckoutCustomerPaymentCard',
})
export default class CmgCheckoutCustomerPaymentCard extends Vue {
  message: UniqueValue<string> | null = null;

  @Prop({ required: true, type: Object })
  card!: TokenizedPaymentCard;

  @Prop({ default: false, type: Boolean })
  disabled!: boolean;

  @Prop({ default: false, type: Boolean })
  selected!: boolean;

  @Prop({ default: false, type: Boolean })
  beingRemoved!: boolean;

  @Prop({ required: false, type: Number })
  giftCardBalance?: number;

  @Prop({ required: true, type: Boolean })
  isGiftCardBalanceLoading!: boolean;

  get giftCardInsufficientBalance(): number {
    return this.card.isGiftCard && this.giftCardBalance != null ? this.orderTotal - this.giftCardBalance : 0;
  }

  get giftCardBalanceMessage(): string {
    return this.selected && !this.isGiftCardBalanceLoading && this.giftCardInsufficientBalance > 0
      ? `Pay Remaining Balance ${this.formatPrice(this.giftCardInsufficientBalance)}`
      : '';
  }

  get orderTotal(): number {
    const order = this.$services.order.getCurrentOrder();
    if (!order) {
      return 0;
    }

    return order.order.orderTotalAmount;
  }

  get lastFourOfCardNumber(): string {
    const number = this.card.tokenizedAccountNumber;

    return this.card.lastFourAccountNumbers ? this.card.lastFourAccountNumbers : number.slice(number.length - 4);
  }

  get canBeRemoved(): boolean {
    return (this.card.isOneTimePaymentCard || this.disabled) && ((!!this.card.isGiftCard && !this.isGiftCardBalanceLoading) || !this.card.isGiftCard);
  }

  formatPrice(price: number | null): string {
    return price == null ? '' : this.$services.utils.formatPrice(price);
  }

  onSelectCard() {
    if (this.card.isGiftCard && this.giftCardBalance === 0) {
      this.message = makeUniqueValue('Gift Card Balance is empty.');
    }

    if (this.disabled) {
      return;
    }

    this.$emit('select-card', this.card);
  }

  onRemoveCard() {
    this.$emit('remove-card', this.card);
  }
}
